function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.2 25.8l1.3.7c-1 1.4-2.5 2.5-4.8 2.5-3.6 0-6.4-2.6-6.4-6.5s2.9-6.5 6.4-6.5c2.3 0 3.8 1.1 4.8 2.5l-1.3.7c-.7-1.1-2-1.8-3.5-1.8-2.7 0-4.8 2.1-4.8 5.1 0 3 2.1 5.1 4.8 5.1 1.5 0 2.8-.8 3.5-1.8zm3.3 3h1.4V16.2h-1.4v12.6zM24.6 11h-7.7l5.5-4.2v1.9c0 .3.2.5.5.5s.5-.2.5-.5V5.4c0-.3-.2-.5-.5-.5h-3.3c-.3 0-.5.2-.5.5s.2.5.5.5h2.2l-5.5 4.2-10.5-9c-.3-.2-.6-.1-.8.1-.2.2-.2.5.1.7L15.7 11H6c-.3 0-.5.2-.5.5s.2.5.5.5h18.6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
})));